import {
    type DuplicateFormForAdminResponse,
    type DuplicateFormForAdminPayload
} from "./type";
import {
    request
} from "../request";

const duplicateFormForAdmin = async (
    payload: DuplicateFormForAdminPayload
): Promise<DuplicateFormForAdminResponse> => {
    return await request<DuplicateFormForAdminResponse>("/events/duplicateForm", {
        body: JSON.stringify(payload),
        method: "POST"
    });
};

export default duplicateFormForAdmin;
